<mat-form-field>
  <mat-label>Interface</mat-label>
  <mat-chip-grid #chipList aria-label="Interface selection">
    @for (interface of selectedInterfaces; track interface) {
    <mat-chip [removable]="removable" (removed)="remove(interface)">
      {{ interface.name }}
      @if (removable) {
      <mat-icon matChipRemove>cancel</mat-icon>
      }
    </mat-chip>
    }
    <input
      placeholder="Interface"
      #interfaceInput
      [formControl]="interfaceCtrl"
      [matAutocomplete]="auto"
      [matChipInputFor]="chipList"
      [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
      (matChipInputTokenEnd)="add($event)"
    />
  </mat-chip-grid>
  <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
    @for (interface of filteredInterfaces | async; track interface) {
    <mat-option [value]="interface">
      {{ interface.name }}
    </mat-option>
    }
  </mat-autocomplete>
</mat-form-field>
